export default import.meta.ROLLDOWN_FILE_URL_xlmbU1NtSFLrwBshE2JTng